/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import Reveal from "./Reveal";
import { fetchImpact } from "@/lib/api";

const DEFAULT_IMPACT = { goal: 30000, planted: 5400, year: 2026 };

function formatNumber(n) {
  return (n ?? 0).toLocaleString();
}

export default function Counter() {
  const [impact, setImpact] = useState(DEFAULT_IMPACT);

  useEffect(() => {
    let mounted = true;
    fetchImpact()
      .then((d) => { if (mounted && d) setImpact(d); })
      .catch(() => {}); // Silent fallback to defaults
    return () => { mounted = false; };
  }, []);

  const pct = Math.min(100, Math.round((impact.planted / (impact.goal || 1)) * 100));

  return (
    <section className="section counter-section">
      <div className="section-inner">
        <div className="counter-grid">
          <div>
            <Reveal className="eyebrow">Our {impact.year} Goal</Reveal>
            <Reveal as="h2" delay={1} className="section-headline">
              Growing India.
              <br />
              <em>One gift at a time.</em>
            </Reveal>
            <Reveal as="p" delay={2} className="counter-body">
              This year, we're aiming to plant {formatNumber(impact.goal)} trees across India. Every hamper you send takes us one step closer. <strong>Help us reach the goal</strong> — one gift, one tree, at a time.
            </Reveal>
          </div>
          <Reveal delay={1} className="counter-box" data-testid="impact-counter">
            <div className="counter-number" data-testid="impact-goal">{formatNumber(impact.goal)}</div>
            <div className="counter-label">Trees · Our {impact.year} Goal</div>
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
            <div className="progress-text" data-testid="impact-planted">
              {formatNumber(impact.planted)} planted so far · Help us grow India
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
